import { render } from "./VersioningCommentModal.vue?vue&type=template&id=4154cf7e"
import script from "./VersioningCommentModal.vue?vue&type=script&lang=js"
export * from "./VersioningCommentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__